// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles for the upload page (PDFSelector) and the "Add PDFs" modal in App.js. */

.pdfu-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 36px 24px;
  border: 2px dashed #c7d2e3;
  border-radius: 14px;
  background: #f8faff;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s, transform 0.15s;
  outline: none;
}
.pdfu-drop:hover,
.pdfu-drop:focus-visible {
  border-color: #1a73e8;
  background: #f1f6ff;
}
.pdfu-drop.is-dragging {
  border-color: #1a73e8;
  border-style: solid;
  background: #e8f0fe;
  transform: scale(1.01);
}
.pdfu-drop--compact {
  padding: 24px 16px;
}

.pdfu-drop-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e8f0fe;
  color: #1a73e8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 6px;
}
.pdfu-drop--compact .pdfu-drop-icon {
  width: 44px;
  height: 44px;
  font-size: 21px;
}
.pdfu-drop-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}
.pdfu-link {
  color: #1a73e8;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.pdfu-drop-hint {
  font-size: 12.5px;
  color: #6b7280;
}
.pdfu-drop-warn {
  margin-top: 6px;
  font-size: 12px;
  color: #b45309;
  background: #fef3c7;
  padding: 4px 10px;
  border-radius: 6px;
}

/* ── Chosen files ── */
.pdfu-list {
  list-style: none;
  margin: 14px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 220px;
  overflow-y: auto;
}
.pdfu-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  animation: pdfu-in 0.18s ease-out;
}
.pdfu-list-icon {
  color: #dc2626;
  font-size: 18px;
  flex-shrink: 0;
}
.pdfu-list-name {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pdfu-list-size {
  font-size: 12px;
  color: #9ca3af;
  flex-shrink: 0;
}
.pdfu-icon-btn {
  border: none;
  background: none;
  color: #9ca3af;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}
.pdfu-icon-btn:hover {
  background: #fee2e2;
  color: #dc2626;
}

/* ── Buttons ── */
.pdfu-btn {
  border: none;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s, box-shadow 0.15s;
  white-space: nowrap;
}
.pdfu-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.pdfu-btn--primary {
  background: #1a73e8;
  color: #fff;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);
}
.pdfu-btn--primary:hover:not(:disabled) {
  background: #1765cc;
}
.pdfu-btn--secondary {
  background: #f1f3f4;
  color: #1f2937;
  padding: 8px 14px;
  min-width: 64px;
}
.pdfu-btn--secondary:hover:not(:disabled) {
  background: #e3e6e8;
}

/* ── URL form ── */
.pdfu-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 12px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #9ca3af;
}
.pdfu-divider::before,
.pdfu-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}
.pdfu-url-row {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 4px 4px 4px 10px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.pdfu-url-row:focus-within {
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);
}
.pdfu-url-icon {
  color: #9ca3af;
  font-size: 18px;
}
.pdfu-url-row input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 13.5px;
  padding: 6px 0;
  background: transparent;
}
.pdfu-error {
  margin-top: 6px;
  font-size: 12px;
  color: #dc2626;
}

.pdfu-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: pdfu-spin 0.7s linear infinite;
}

@keyframes pdfu-spin {
  to { transform: rotate(360deg); }
}
@keyframes pdfu-in {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: none; }
}

/* ── Upload page (PDFSelector) ── */
.pdfu-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 15% 10%, rgba(26, 115, 232, 0.10), transparent 45%),
    radial-gradient(circle at 85% 90%, rgba(124, 58, 237, 0.08), transparent 45%),
    #f5f7fb;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.pdfu-card {
  width: 100%;
  max-width: 540px;
  background: #fff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06), 0 12px 40px rgba(16, 24, 40, 0.08);
  box-sizing: border-box;
}
.pdfu-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.pdfu-brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1a73e8, #6d4aff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.pdfu-brand-name {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
}
.pdfu-title {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}
.pdfu-subtitle {
  margin: 0 0 22px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
.pdfu-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}
.pdfu-actions .pdfu-btn--primary {
  flex: 1 1;
}
.pdfu-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  color: #4b5563;
  font-size: 14px;
}
.pdfu-loading .pdfu-spinner {
  width: 28px;
  height: 28px;
  border-width: 3px;
  color: #1a73e8;
}

/* ── "Add PDFs" modal ── */
.pdfu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: pdfu-fade 0.15s ease-out;
}
.pdfu-modal {
  width: 480px;
  max-width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 22px 24px 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  animation: pdfu-pop 0.18s ease-out;
}
.pdfu-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.pdfu-modal-title {
  font-size: 17px;
  font-weight: 700;
  color: #111827;
}
.pdfu-modal-head .pdfu-icon-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

@keyframes pdfu-fade {
  from { opacity: 0; }
}
@keyframes pdfu-pop {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
}

/* ── "+" in the Files tab bar ── */
.pdf-add-tab-btn {
  width: 24px;
  height: 24px;
  margin: 4px 4px 0;
  border-radius: 6px;
  border: 1px dashed #c7d2e3;
  background: transparent;
  color: #5f6368;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}
.pdf-add-tab-btn:hover {
  border-style: solid;
  border-color: #1a73e8;
  background: #e8f0fe;
  color: #1a73e8;
}
`, "",{"version":3,"sources":["webpack://./src/components/pdf/PdfUpload.css"],"names":[],"mappings":"AAAA,wFAAwF;;AAExF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,iEAAiE;EACjE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB;;;WAGS;EACT,8EAA8E;AAChF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gFAAgF;EAChF,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,SAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE;AACrB;AACA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Shared styles for the upload page (PDFSelector) and the \"Add PDFs\" modal in App.js. */\n\n.pdfu-drop {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 36px 24px;\n  border: 2px dashed #c7d2e3;\n  border-radius: 14px;\n  background: #f8faff;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.15s, background 0.15s, transform 0.15s;\n  outline: none;\n}\n.pdfu-drop:hover,\n.pdfu-drop:focus-visible {\n  border-color: #1a73e8;\n  background: #f1f6ff;\n}\n.pdfu-drop.is-dragging {\n  border-color: #1a73e8;\n  border-style: solid;\n  background: #e8f0fe;\n  transform: scale(1.01);\n}\n.pdfu-drop--compact {\n  padding: 24px 16px;\n}\n\n.pdfu-drop-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #e8f0fe;\n  color: #1a73e8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  margin-bottom: 6px;\n}\n.pdfu-drop--compact .pdfu-drop-icon {\n  width: 44px;\n  height: 44px;\n  font-size: 21px;\n}\n.pdfu-drop-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2937;\n}\n.pdfu-link {\n  color: #1a73e8;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.pdfu-drop-hint {\n  font-size: 12.5px;\n  color: #6b7280;\n}\n.pdfu-drop-warn {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #b45309;\n  background: #fef3c7;\n  padding: 4px 10px;\n  border-radius: 6px;\n}\n\n/* ── Chosen files ── */\n.pdfu-list {\n  list-style: none;\n  margin: 14px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.pdfu-list-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  animation: pdfu-in 0.18s ease-out;\n}\n.pdfu-list-icon {\n  color: #dc2626;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n.pdfu-list-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1f2937;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.pdfu-list-size {\n  font-size: 12px;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n.pdfu-icon-btn {\n  border: none;\n  background: none;\n  color: #9ca3af;\n  cursor: pointer;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n.pdfu-icon-btn:hover {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n/* ── Buttons ── */\n.pdfu-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 11px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background 0.15s, box-shadow 0.15s;\n  white-space: nowrap;\n}\n.pdfu-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n.pdfu-btn--primary {\n  background: #1a73e8;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.3);\n}\n.pdfu-btn--primary:hover:not(:disabled) {\n  background: #1765cc;\n}\n.pdfu-btn--secondary {\n  background: #f1f3f4;\n  color: #1f2937;\n  padding: 8px 14px;\n  min-width: 64px;\n}\n.pdfu-btn--secondary:hover:not(:disabled) {\n  background: #e3e6e8;\n}\n\n/* ── URL form ── */\n.pdfu-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 18px 0 12px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #9ca3af;\n}\n.pdfu-divider::before,\n.pdfu-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n}\n.pdfu-url-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  padding: 4px 4px 4px 10px;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.pdfu-url-row:focus-within {\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);\n}\n.pdfu-url-icon {\n  color: #9ca3af;\n  font-size: 18px;\n}\n.pdfu-url-row input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  font-size: 13.5px;\n  padding: 6px 0;\n  background: transparent;\n}\n.pdfu-error {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #dc2626;\n}\n\n.pdfu-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  animation: pdfu-spin 0.7s linear infinite;\n}\n\n@keyframes pdfu-spin {\n  to { transform: rotate(360deg); }\n}\n@keyframes pdfu-in {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: none; }\n}\n\n/* ── Upload page (PDFSelector) ── */\n.pdfu-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n  background:\n    radial-gradient(circle at 15% 10%, rgba(26, 115, 232, 0.10), transparent 45%),\n    radial-gradient(circle at 85% 90%, rgba(124, 58, 237, 0.08), transparent 45%),\n    #f5f7fb;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n.pdfu-card {\n  width: 100%;\n  max-width: 540px;\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06), 0 12px 40px rgba(16, 24, 40, 0.08);\n  box-sizing: border-box;\n}\n.pdfu-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n.pdfu-brand-mark {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #1a73e8, #6d4aff);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n.pdfu-brand-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1f2937;\n}\n.pdfu-title {\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n.pdfu-subtitle {\n  margin: 0 0 22px;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n.pdfu-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 14px;\n}\n.pdfu-actions .pdfu-btn--primary {\n  flex: 1;\n}\n.pdfu-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  color: #4b5563;\n  font-size: 14px;\n}\n.pdfu-loading .pdfu-spinner {\n  width: 28px;\n  height: 28px;\n  border-width: 3px;\n  color: #1a73e8;\n}\n\n/* ── \"Add PDFs\" modal ── */\n.pdfu-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  animation: pdfu-fade 0.15s ease-out;\n}\n.pdfu-modal {\n  width: 480px;\n  max-width: 100%;\n  background: #fff;\n  border-radius: 16px;\n  padding: 22px 24px 24px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  box-sizing: border-box;\n  animation: pdfu-pop 0.18s ease-out;\n}\n.pdfu-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.pdfu-modal-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #111827;\n}\n.pdfu-modal-head .pdfu-icon-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n@keyframes pdfu-fade {\n  from { opacity: 0; }\n}\n@keyframes pdfu-pop {\n  from { opacity: 0; transform: translateY(8px) scale(0.98); }\n}\n\n/* ── \"+\" in the Files tab bar ── */\n.pdf-add-tab-btn {\n  width: 24px;\n  height: 24px;\n  margin: 4px 4px 0;\n  border-radius: 6px;\n  border: 1px dashed #c7d2e3;\n  background: transparent;\n  color: #5f6368;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.15s;\n}\n.pdf-add-tab-btn:hover {\n  border-style: solid;\n  border-color: #1a73e8;\n  background: #e8f0fe;\n  color: #1a73e8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
